import { AxiosError } from "axios"
import { paths } from "./schema"
import { useAppStore } from "../state"
import { createClient } from "../../lib/openapi-axios"
import { ProcessPaths } from "@src/utils/types"
import { API_BASE_URL } from "@src/utils/consts"

export const client = createClient<ProcessPaths<paths>>({
  baseUrl: API_BASE_URL,
})

client.axiosInstance.interceptors.request.use((config) => {
  const token = useAppStore.getState().token

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`
  }

  return config
})

client.axiosInstance.interceptors.response.use(
  (response) => {
    return response
  },
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      useAppStore.setState({ token: "" })
      // Clear persisted query cache so stale user data isn't used on next login
      indexedDB.deleteDatabase("tanstack-query-cache")
      // prevent redirecting to login if already on login page or application definition page
      if (
        window.location.pathname !== "/login" &&
        !window.location.pathname.startsWith("/application-definition") &&
        !window.location.pathname.startsWith("/api/Outlook/SignIn")
      ) {
        window.location.href = "/login"
      }
    }
    return Promise.reject(error)
  },
)
